import { useTranslation } from "react-i18next";

/** Icon buttons for the player header: picture-in-picture and cast / AirPlay. */

const btn =
  "h-8 w-8 inline-flex items-center justify-center rounded border border-border text-text/80 " +
  "hover:border-accent hover:text-text focus-visible:border-accent tv:h-10 tv:w-10";

export function PipButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  return (
    <button type="button" onClick={onClick} className={btn} aria-label={t("picture_in_picture")} title={t("picture_in_picture")}>
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <rect x="12" y="12" width="8" height="6" rx="1" fill="currentColor" stroke="none" />
      </svg>
    </button>
  );
}

export function CastButton({ onClick, active, device }: { onClick: () => void; active: boolean; device?: string }) {
  const { t } = useTranslation();
  const label = active && device ? t("casting_to", { device }) : t("cast");
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={btn + (active ? " text-accent border-accent" : "")}
      aria-label={label}
      title={label}
    >
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
        <path d="M2 16a6 6 0 0 1 6 6M2 12a10 10 0 0 1 10 10M2 20h.01" />
        <path d="M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6" />
      </svg>
    </button>
  );
}

/** Shown over the local player while a Cast session plays the stream elsewhere. */
export function CastingBanner({ device }: { device?: string }) {
  const { t } = useTranslation();
  return (
    <div role="status" className="text-sm text-accent px-1 py-2">
      {device ? t("casting_to", { device }) : t("cast")}
    </div>
  );
}
